import { SummaryOfDeals } from './SummaryOfDeals';

export default SummaryOfDeals;
